import type { BiomarkerFilter } from '~/store/trialSearch/biomarkers.utils';
import { ValueSet } from '@tempus/trials-types';

import axios from '../axios';
import { TRIALS_API_ROOT } from '../constants';
import { AggregateValueSetsResponse, GetAllValueSetsResponse } from '../types/valuesets';

export const dropdownsApi = {
  getBiomarkers: async (search: string): Promise<BiomarkerFilter[]> => {
    return axios
      .get(`${TRIALS_API_ROOT}/v1/dropdowns/biomarker-filters`, {
        params: { search },
      })
      .then(({ data }) => data);
  },
  getValueSet: async (valuesetName: string): Promise<ValueSet[]> => {
    return axios.get(`${TRIALS_API_ROOT}/valuesets/${valuesetName}`).then(({ data }) => data);
  },
  getAllValueSets: async (): Promise<AggregateValueSetsResponse> => {
    return axios
      .get<GetAllValueSetsResponse>(`${TRIALS_API_ROOT}/valuesets/all`)
      .then(({ data: { valuesets } }) => valuesets);
  },
};
